export default __webpack_public_path__ + "static/media/pdv_logo.cdda437e.png";